module.exports = __webpack_public_path__ + "img/Barbara Van Hare Broad photo.82019b25.jpg";